const comments = [
  {
    name: '追剧小达人',
    avatar: 'ri-user-3-line',
    time: '2小时前',
    content: '终于找到一个更新这么快的影视导航站了！之前每次都要在好几个平台之间跳来跳去找新剧，现在每天打开久久影视看一眼就知道今天该追什么了，影视更新快名不虚传！',
    likes: '128',
  },
  {
    name: '电影控阿明',
    avatar: 'ri-user-3-line',
    time: '5小时前',
    content: '最新电影上映信息太全了，而且不只是院线片，连一些小众影展和流媒体上线的新片都有整理。作为一个重度电影爱好者，这个站真的是追剧党首选，强烈安利给所有影迷朋友。',
    likes: '96',
  },
  {
    name: '综艺追不停',
    avatar: 'ri-user-3-line',
    time: '昨天',
    content: '最新综艺在线同步速度真的快！《声入人心》新一季上线当天就在久久影视看到了，而且高清不卡，用手机在地铁上看综艺也完全不缓冲。每天通勤时间终于有着落了。',
    likes: '74',
  },
  {
    name: '剧荒拯救者',
    avatar: 'ri-user-3-line',
    time: '昨天',
    content: '被朋友安利过来的，本来只是想看看最近有什么新剧，结果在"专题合集"里挖到了好几部冷门好剧。新剧抢先看的功能太实用了，以后再也不怕剧荒了，感谢久久影视！',
    likes: '53',
  },
  {
    name: '深夜追剧人',
    avatar: 'ri-user-3-line',
    time: '2天前',
    content: '用了久久影视三个月了，最大的感受就是省心。最新电视剧更新一目了然，影视动态也很及时。页面干净没有乱七八糟的广告，深夜刷剧体验满分。希望久久影视越做越好！',
    likes: '41',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
            追剧人说
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            来自真实追剧党的声音，听听他们对久久影视的评价
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 max-w-5xl mx-auto">
          {comments.map((comment, idx) => (
            <div
              key={idx}
              className={`p-5 md:p-6 rounded-lg bg-background-50 border border-background-200/70 ${
                idx === comments.length - 1 ? 'lg:col-span-1 lg:col-start-2' : ''
              }`}
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-9 h-9 rounded-full bg-secondary-100 flex items-center justify-center flex-shrink-0">
                  <i className={`${comment.avatar} text-sm text-secondary-600`}></i>
                </div>
                <div className="min-w-0">
                  <div className="text-sm font-medium text-foreground-900 whitespace-nowrap">
                    {comment.name}
                  </div>
                  <div className="text-xs text-foreground-500">{comment.time}</div>
                </div>
              </div>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed mb-3">
                {comment.content}
              </p>
              <div className="flex items-center gap-1 text-xs text-foreground-500">
                <i className="ri-heart-line text-accent-500"></i>
                <span>{comment.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}